"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext } from "react";
import { useCookieConsent } from "#/features/cookieConsent/hooks/useCookieConsent";
type CookieConsentContextValue = {
  openCookieSettings: () => void;
};
const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);
export const useOptionalCookieConsentContext = () => {
  return useContext(CookieConsentContext);
};
type CookieConsentProviderProps = {
  children: React.ReactNode;
  value: CookieConsentContextValue;
};
export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = t0 => {
  const $ = _c(3);
  const {
    children,
    value
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useCookieConsentController = () => {
  return useCookieConsent();
};